import React from "react";
import main from "../assets/images/main.svg";
import Wrapper from "../assets/wrappers/LandingPage"
import { Logo } from "../components";
import { Link } from "react-router-dom";

const Landing = () => {
    return (
        <Wrapper>
            <nav>
                <Logo />
            </nav>
            <div className="container page">
                <div className="info">
                    <h1>
                        job <span>tracking</span> app
                    </h1>
                    <p>
                        A job tracking app to help individuals
                        and businesses manage and monitor various aspects of their
                        work-related activities. Whether you're a freelancer, a small
                        business owner, a project manager, or an employee looking to stay
                        organized, a job tracking app can be a valuable asset.
                    </p>
                    <Link to={"/register"} className="btn btn-hero">Login/Register</Link>
                </div>
                <img src={main} className="main-img" alt="main-img" />
            </div>
        </Wrapper>
    );
};

// Styled components

// const Wrapper = styled.main`
// nav{
//     width:var(--fluid-width);
//     max-width:var(--max-width);
//     margin: 0 auto;
//     height: var(--nav-height);
//     display: flex;
//     align-items: center;
// }
// .page {
//     min-height: calc(100vh - var(--nav-height));
//     display: grid;
//     align-items: center;
//     margin-top: -3rem;
// }

// h1 {
//     font-weight: 700;
//     span {
//         color: var(--primary-500);
//     }
// }

// p {
//     color: var(--grey-600);
// }

// .main-img {
//     display: none;
// }

// @media(min-width: 992px) {
//     .page {
//         grid-template-columns: 1fr 1fr;
//         column-gap: 3rem;
//     }
//     .main-img {
//         display: block;
//     }
// }
// `;

export default Landing;
